"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var event = require("./event");
var Controller = /** @class */ (function () {
    function Controller(options) {
        var _this = this;
        this.enableEditor = true;
        this.autoId = 0;
        this.__mode__ = window.BVD_MODE;
        if (typeof this.__mode__ === "undefined") {
            this.__mode__ = "standalone";
        }
        this.dataLoader = options.dataLoader;
        this.visualizer = options.visualizer;
        this.visualizer.controller = this;
        this.editorDef = options.editorDef || { sections: [] };
        this.toolbarDef = options.toolbarDef || this.defaultToolbarDef();
        this.editorRefs = {};
        if (this.__mode__ === "standalone") {
            document.addEventListener("DOMContentLoaded", function () {
                _this.run();
            });
        }
        else if (this.__mode__ === "run-on-event") {
            event.on(event.CANVAS_READY, function () {
                _this.run();
            });
        }
        else {
            var setupVue_1 = function (vue) {
                vue.$root.$data.controller = _this;
                _this.vue = vue;
                _this.vue.editorConfig = _this.editorDef;
                _this.vue.toolbarConfig = _this.toolbarDef;
            };
            var vue = event.rpc("getVue");
            if (vue) {
                setupVue_1(vue);
            }
            event.on(event.CANVAS_MOUNTED, function (_, vue) {
                if (window.BVD_CURRENT_MODULE !== _this.__name__) {
                    return;
                }
                setupVue_1(vue);
            });
            event.on(event.CANVAS_READY, function (_, vue) {
                if (window.BVD_CURRENT_MODULE !== _this.__name__) {
                    return;
                }
                _this.run();
            });
        }
    }
    Controller.prototype.run = function () {
        var _this = this;
        this._init();
        this.init();
        event.emit(event.CANVAS_INITIALIZED, this);
        this.loadData().then(function () {
            _this.runVisualizer();
        }).catch(function (error) {
            event.emit(event.DATA_LOADING_FAILED, error.toString());
            // tslint:disable-next-line
            console.log(error);
        });
    };
    Controller.prototype.init = function () { return; };
    Controller.prototype._init = function () {
        var _this = this;
        this.canvas = $("#canvas");
        this.toolbar = $(".v-toolbar .left");
        this.toolbarRight = $(".v-toolbar .right");
        this.fsContainer = $("#fs-container");
        this.svgSize = this.canvas.find(".svg-size");
        this.canvasWidth = this.canvas.innerWidth();
        this.canvasHeight = 500;
        this.visualizer.size.width = this.canvasWidth;
        // this.visualizer.size.height = this.canvasHeight;
        this.visualizer.initCanvas();
        this.svg = $(this.visualizer.svg.node());
        event.on("bvd3.drawFinished", function () {
            _this.canvasWidth = _this.svg.width();
            _this.canvasHeight = _this.svg.height();
            // this.updateSvgSizeText();
        });
        this.updateSvgSizeText();
        // this.canvasToolbar.find(".redraw-btn").on("click", () => {
        //     this.reRunVisualizer();
        // });
        // on resize
        $(window).on("resize bvd3.canvasResize", function () {
            _this.canvasWidth = _this.canvas.innerWidth();
            _this.updateSvgSizeText();
            _this.setSvgSizeAndRedraw();
        });
        // drag resize
        this.isResizingH = false;
        this.canvas.find(".svg-resize-h").on("mousedown", function (e) {
            _this.isResizingH = true;
            _this.lastY = e.pageY;
        });
        $(document).on("mousemove", function (e) {
            if (!_this.isResizingH) {
                return;
            }
            _this.canvasHeight = _this.canvasHeight + (e.pageY - _this.lastY);
            // if (this.canvasHeight > this.maxCanvasHeight) { this.canvasHeight = this.maxCanvasHeight; }
            // if (this.canvasHeight < this.minCanvasHeight) { this.canvasHeight = this.minCanvasHeight; }
            _this.lastY = e.pageY;
            _this.setSvgSizeAndRedraw();
            _this.updateSvgSizeText();
        }).on("mouseup", function (e) {
            _this.isResizingH = false;
        });
        document.addEventListener("turbolinks:before-render", function () {
            _this.uninit();
        });
    };
    Controller.prototype.uninit = function () {
        $(window).off("resize bvd3.canvasResize");
        $(document).off("mousemove");
    };
    Controller.prototype.dataWillLoad = function () { return true; };
    Controller.prototype.dataDidLoaded = function () {
        this.visualizer.initData(this.dataLoader.data);
    };
    Controller.prototype.loadData = function () {
        var _this = this;
        if (this.dataWillLoad()) {
            return this.dataLoader.load().then(function () {
                _this.dataDidLoaded();
            });
        }
    };
    Controller.prototype.visualizerWillDraw = function () { return true; };
    Controller.prototype.visualizerDidDrawn = function () { return; };
    Controller.prototype.runVisualizer = function () {
        if (this.visualizerWillDraw()) {
            this.visualizer.run();
        }
        this.visualizerDidDrawn();
    };
    Controller.prototype.updateSvgSizeText = function () {
        this.svgSize.html(this.canvasWidth + " &times; " + this.canvasHeight);
    };
    Controller.prototype.triggerCanvasResize = function () {
        // dispatch event
        var e = new $.Event("bvd3.canvasResize");
        $(window).trigger(e);
    };
    Controller.prototype.setSvgSizeAndRedraw = function () {
        this.visualizer.size.width = this.canvasWidth;
        this.visualizer.size.height = this.canvasHeight;
        this.visualizer.startDraw();
    };
    Controller.prototype.defaultToolbarDef = function () {
        var items = [{
                type: "button",
                name: "Download",
                icon: "download",
                callback: function () { return; },
            }, {
                type: "button",
                name: "Redraw",
                icon: "sync-alt",
                callback: function () { return; },
            }];
        return [{ type: "btn-group", items: items }];
    };
    return Controller;
}());
exports.Controller = Controller;
//# sourceMappingURL=controller.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/controller.js
// module id = 883
// module chunks = 0 1